import { useEffect, useState } from "react";
import LandingPage from "../pages/Landing/LandingPage";
import Layout from "../Layouts/Layout";
import Loading from "../components/Loading/Loading";
import UserStorePage from "../pages/UserStorePage/UserStorePage";
import GetUserInfoService from "../service/GetUserInfoService";
import { isReservedStoreSlug } from "../utilities/storeSlug";

/**
 * Resolve "/:slug" para a loja do usuário. Se o slug não pertence a nenhuma loja,
 * mantém o comportamento anterior da rota curinga: mostra a landing page.
 */
const StoreSlugRoute = ({ slug }) => {
  const reserved = isReservedStoreSlug(slug);
  const [lookup, setLookup] = useState({ slug: null, username: null });

  useEffect(() => {
    if (reserved) return undefined;

    let cancelled = false;

    new GetUserInfoService()
      .getShopBySlug(slug)
      .then((res) => {
        if (cancelled) return;
        const username =
          res?.messageCode === 200001 ? res?.result?.shopConfiguration?.user?.username : null;
        setLookup({ slug, username: username || null });
      })
      .catch(() => {
        if (!cancelled) setLookup({ slug, username: null });
      });

    return () => {
      cancelled = true;
    };
  }, [slug, reserved]);

  if (reserved) return <LandingPage />;
  if (lookup.slug !== slug) return <Loading />;
  if (!lookup.username) return <LandingPage />;

  return (
    <Layout hasSearch={true}>
      <UserStorePage key={lookup.username} user={lookup.username} />
    </Layout>
  );
};

export default StoreSlugRoute;
